import { useRef, useState, type Dispatch, type SetStateAction } from 'react';

/**
 * Ein Formular, dessen Werte nachgeliefert werden (7.78).
 *
 * Die Einstellungsblätter zeigen ihre Felder sofort und holen erst danach,
 * was darin stehen soll. Wer schneller tippt als der Server antwortet, sah
 * sein Getipptes wieder verschwinden -- beim Ablage-Blatt blieb danach sogar
 * der Speichern-Knopf grau, weil zwei Pflichtfelder wieder leer waren, und
 * man konnte nicht einmal mehr sagen, warum.
 *
 * Gefunden hat das der Browser-Durchgang bei einem Viertel der Wartezeiten:
 * dort tippt er schneller, als die Antwort kommt. Er hatte recht, und die App
 * hatte unrecht -- das ist die fünfte Sorte im Grind (7.78).
 *
 * Die Regel ist einfach: **was jemand angefasst hat, überschreibt keine
 * Antwort, die noch unterwegs war.** Ein Wert, den die App selbst setzt --
 * nach „Vergessen“ etwa --, gilt dabei als angefasst: er ist ja gewollt.
 */
export function useNachgeliefert<T>(
  anfang: T,
): [T, Dispatch<SetStateAction<T>>, (nachtrag: (alt: T) => T) => void] {
  const [wert, setzen] = useState(anfang);
  const angefasst = useRef(false);
  const setzenGemerkt: Dispatch<SetStateAction<T>> = (naechster) => {
    angefasst.current = true;
    setzen(naechster);
  };
  const nachliefern = (nachtrag: (alt: T) => T): void => {
    setzen((alt) => (angefasst.current ? alt : nachtrag(alt)));
  };
  return [wert, setzenGemerkt, nachliefern];
}
